import React from 'react';

interface IProgressBarProps {
  value: number;
  max?: number;
  showPercentage?: boolean;
  barColor?: string;
  backgroundColor?: string;
  height?: string;
  className?: string;
}

const ProgressBar: React.FC<IProgressBarProps> = ({
  value,
  max = 100,
  showPercentage = true,
  barColor = 'bg-brand-default',
  backgroundColor = 'bg-neutral-50',
  height = 'h-2',
  className = '',
}) => {
  const percentage = Math.min(Math.max((value / max) * 100, 0), 100);

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className={`flex-1 ${backgroundColor} rounded-full ${height}`}>
        <div
          className={`${barColor} ${height} rounded-full transition-all duration-300`}
          style={{ width: `${percentage}%` }}
        />
      </div>
      {showPercentage && (
        <span className="text-sm font-medium text-gray-700 min-w-8.75">
          {Math.round(percentage)}%
        </span>
      )}
    </div>
  );
};

export default ProgressBar;
